import React from 'react';
import {Box, Typography} from '@mui/material';
import useTranslations from '../../hooks/useTranslation';

const AdminMobileRestrictedOverlay = ({ 
  children, 
  isRestricted = false, 
  message = 'Please use desktop for Admin role',
  opacity = 0.2 
}) => {
  const {translate} = useTranslations();

  return (
    <Box sx={{ position: 'relative', width: '100%', height: '100%' }}>
      {/* Content */}
      <Box 
        sx={{ 
          opacity: isRestricted ? opacity : 1,
          transition: 'opacity 0.3s ease-in-out',
          pointerEvents: isRestricted ? 'none' : 'auto'
        }}
      >
        {children}
      </Box>

      {/* Overlay */}
      {isRestricted && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
            paddingTop: '15%',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(2px)',
            zIndex: 10
          }}
        >
          <Box
            sx={{
              backgroundColor: '#ffffff',
              border: '2px solid #d32f2f',
              borderRadius: '12px',
              padding: '24px 32px',
              textAlign: 'center',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
              maxWidth: '400px',
              mx: 2
            }}
          >
            <Typography
              variant="h6"
              sx={{
                color: '#d32f2f',
                fontWeight: 'bold',
                mb: 1
              }}
            >
              {translate('Mobile Access Restricted')}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: '#333333',
                lineHeight: 1.5
              }}
            >
              {translate(message)}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AdminMobileRestrictedOverlay;
